export default "__VITE_ASSET__BrODyBTM__"